import { User, Mail, Phone } from "lucide-react";
import { Input } from "@/shared/components/ui/input";
import { SectionCard, FormRow } from "./DepositUI";

export default function CustomerDetailsSection({
  form,
  updateField,
  validateField,
  errors,
  fieldRefs,
}) {
  return (
    <SectionCard icon={User} title="Customer Details">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <FormRow id="firstname" label="First Name *" error={errors.firstname}>
          <Input
            id="firstname"
            ref={(el) => (fieldRefs.current.firstname = el)}
            value={form.firstname}
            onChange={(e) => updateField("firstname", e.target.value)}
            onBlur={(e) => validateField("firstname", e.target.value)}
            placeholder="Ahmed"
            maxLength={100}
            className="h-11 rounded-xl"
          />
        </FormRow>

        <FormRow id="lastname" label="Last Name *" error={errors.lastname}>
          <Input
            id="lastname"
            ref={(el) => (fieldRefs.current.lastname = el)}
            value={form.lastname}
            onChange={(e) => updateField("lastname", e.target.value)}
            onBlur={(e) => validateField("lastname", e.target.value)}
            placeholder="Khan"
            maxLength={100}
            className="h-11 rounded-xl"
          />
        </FormRow>

        <FormRow
          id="email"
          label="Email *"
          error={errors.email}
          icon={Mail}
        >
          <Input
            id="email"
            ref={(el) => (fieldRefs.current.email = el)}
            type="email"
            autoComplete="email"
            value={form.email}
            onChange={(e) => updateField("email", e.target.value)}
            onBlur={(e) => validateField("email", e.target.value)}
            placeholder="customer@example.com"
            className="pl-10 h-11 rounded-xl"
          />
        </FormRow>

        <FormRow
          id="phone"
          label="Wallet Number *"
          error={errors.phone}
          icon={Phone}
          hint="11-digit number starting with 03"
        >
          <Input
            id="phone"
            ref={(el) => (fieldRefs.current.phone = el)}
            value={form.phone}
            onChange={(e) =>
              updateField(
                "phone",
                e.target.value.replace(/[^0-9]/g, ""),
              )
            }
            onBlur={(e) => validateField("phone", e.target.value)}
            placeholder="03XXXXXXXXX"
            maxLength={11}
            className="pl-10 h-11 rounded-xl"
          />
        </FormRow>
      </div>
    </SectionCard>
  );
}
